import { render } from "./FeaturedScene.vue?vue&type=template&id=6762e373&ts=true"
import script from "./FeaturedScene.vue?vue&type=script&lang=ts"
export * from "./FeaturedScene.vue?vue&type=script&lang=ts"

import "./FeaturedScene.vue?vue&type=style&index=0&id=6762e373&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__